import React from 'react';

import moment from 'moment';

// eslint-disable-next-line no-unused-vars
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { withMediaQueries } from 'hoc/withMediaQueries';
import MainFont from 'ui/typography/mainFont';

import {
  ContentWrapper,
  DetaildDataItem,
  DetailsDataContainer,
  DetailsTitle,
  DetailsWrapper,
  Item,
  ItemTitle,
  NotAvailable
} from './style';

const DetailsCard = ({ details = {}, corporate = false }) => {
  const { t } = useTranslation();

  return (
    <ContentWrapper>
      {Object.keys(details).length <= 0 ? (
        <NotAvailable>
          <MainFont
            type="4"
            configuration={{ fontSize: 16, lineHeight: '1.5' }}
          >
            {t('not_available')}
          </MainFont>
        </NotAvailable>
      ) : (
        <>
          <DetailsWrapper>
            <DetailsTitle>
              <MainFont
                type="4"
                configuration={{ fontSize: 16, lineHeight: '1.5' }}
              >
                {t('device_details')}
              </MainFont>
            </DetailsTitle>
            <DetailsDataContainer>
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('serialNumber')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {details?.chargePointSerialNumber || '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('model')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {details?.chargePointModel || '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('firmware_version')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {details?.firmwareVersion || '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
            </DetailsDataContainer>
          </DetailsWrapper>

          <DetailsWrapper>
            <DetailsTitle>
              <MainFont
                type="4"
                configuration={{ fontSize: 12, lineHeight: '1.5' }}
              >
                {t('other_details')}
              </MainFont>
            </DetailsTitle>
            <DetailsDataContainer>
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('connectors')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {
                      details?.connectors?.filter(c => c.connectorId !== '0')
                        .length
                    }
                  </MainFont>
                </Item>
              </DetaildDataItem>
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('charging_point_max_power')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {details?.maxPowerCp || '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
              {!corporate && (
                <DetaildDataItem>
                  <ItemTitle>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.33' }}
                    >
                      {t('protocol')}
                    </MainFont>
                  </ItemTitle>
                  <Item>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.55' }}
                    >
                      {details?.protocol || '-'}
                    </MainFont>
                  </Item>
                </DetaildDataItem>
              )}
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('last_device_transmission')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {(details?.lastUpdate &&
                      moment(details?.lastUpdate).format(
                        'DD/MM/YYYY, h:mm:ss'
                      )) ||
                      '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('last_usage')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {(details?.lastUsage &&
                      moment(details?.lastUsage).format(
                        'DD/MM/YYYY, h:mm:ss'
                      )) ||
                      '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
            </DetailsDataContainer>
          </DetailsWrapper>

          <DetailsWrapper>
            <DetailsTitle>
              <MainFont
                type="4"
                configuration={{ fontSize: 12, lineHeight: '1.5' }}
              >
                {t('location')}
              </MainFont>
            </DetailsTitle>
            <DetailsDataContainer>
              {corporate && (
                <DetaildDataItem>
                  <ItemTitle>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.33' }}
                    >
                      {t('site')}
                    </MainFont>
                  </ItemTitle>
                  <Item>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.55' }}
                    >
                      {details?.site || '-'}
                    </MainFont>
                  </Item>
                </DetaildDataItem>
              )}
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('country')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {details?.country || '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('region')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {details?.region || '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('city')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {details?.city || '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
              {!corporate && (
                <DetaildDataItem>
                  <ItemTitle>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.33' }}
                    >
                      {t('site')}
                    </MainFont>
                  </ItemTitle>
                  <Item>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.55' }}
                    >
                      {details?.site || '-'}
                    </MainFont>
                  </Item>
                </DetaildDataItem>
              )}
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('address')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {details?.address || '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('zip_code')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {details?.postalCode || '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('longitude')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {details?.coordinates?.longitude || '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
              <DetaildDataItem>
                <ItemTitle>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.33' }}
                  >
                    {t('latitude')}
                  </MainFont>
                </ItemTitle>
                <Item>
                  <MainFont
                    configuration={{ fontSize: 12, lineHeight: '1.55' }}
                  >
                    {details?.coordinates?.latitude || '-'}
                  </MainFont>
                </Item>
              </DetaildDataItem>
            </DetailsDataContainer>
          </DetailsWrapper>

          {!corporate && (
            <DetailsWrapper>
              <DetailsTitle>
                <MainFont
                  type="4"
                  configuration={{ fontSize: 12, lineHeight: '1.5' }}
                >
                  {t('connectivity')}
                </MainFont>
              </DetailsTitle>
              <DetailsDataContainer>
                <DetaildDataItem>
                  <ItemTitle>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.33' }}
                    >
                      {t('connectivity_type')}
                    </MainFont>
                  </ItemTitle>
                  <Item>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.55' }}
                    >
                      {details?.connectivity?.connectivityType}
                    </MainFont>
                  </Item>
                </DetaildDataItem>
                <DetaildDataItem>
                  <ItemTitle>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.33' }}
                    >
                      {t('imsi')}
                    </MainFont>
                  </ItemTitle>
                  <Item>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.55' }}
                    >
                      {details?.connectivity?.imsi}
                    </MainFont>
                  </Item>
                </DetaildDataItem>
                <DetaildDataItem>
                  <ItemTitle>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.33' }}
                    >
                      {t('iccid')}
                    </MainFont>
                  </ItemTitle>
                  <Item>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.55' }}
                    >
                      {details?.connectivity?.iccid}
                    </MainFont>
                  </Item>
                </DetaildDataItem>
                <DetaildDataItem>
                  <ItemTitle>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.33' }}
                    >
                      {t('MSISDN')}
                    </MainFont>
                  </ItemTitle>
                  <Item>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.55' }}
                    >
                      {details?.connectivity?.msisdn}
                    </MainFont>
                  </Item>
                </DetaildDataItem>
                <DetaildDataItem>
                  <ItemTitle>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.33' }}
                    >
                      {t('successful_connection')}
                    </MainFont>
                  </ItemTitle>
                  <Item>
                    <MainFont
                      configuration={{ fontSize: 12, lineHeight: '1.55' }}
                    >
                      {details?.connectivity?.connectedSystem === true
                        ? 'Yes'
                        : details?.connectivity?.connectedSystem === false
                        ? 'No'
                        : ''}
                    </MainFont>
                  </Item>
                </DetaildDataItem>
              </DetailsDataContainer>
            </DetailsWrapper>
          )}
          {details?.connectors
            ?.filter(item => item.connectorId !== '0')
            .map((connector, index) => (
              <DetailsWrapper key={index}>
                <DetailsTitle>
                  <MainFont
                    type="4"
                    configuration={{ fontSize: 12, lineHeight: '1.5' }}
                  >
                    {t('connector')} {connector?.standard}
                  </MainFont>
                </DetailsTitle>
                <DetailsDataContainer>
                  <DetaildDataItem>
                    <ItemTitle>
                      <MainFont
                        configuration={{ fontSize: 12, lineHeight: '1.33' }}
                      >
                        {t('id')}
                      </MainFont>
                    </ItemTitle>
                    <Item>
                      <MainFont
                        configuration={{ fontSize: 12, lineHeight: '1.55' }}
                      >
                        {connector?.connectorId || '-'}
                      </MainFont>
                    </Item>
                  </DetaildDataItem>
                  <DetaildDataItem>
                    <ItemTitle>
                      <MainFont
                        configuration={{ fontSize: 12, lineHeight: '1.33' }}
                      >
                        {t('min_power')}
                      </MainFont>
                    </ItemTitle>
                    <Item>
                      <MainFont
                        configuration={{ fontSize: 12, lineHeight: '1.55' }}
                      >
                        {connector?.minPower || '-'}
                      </MainFont>
                    </Item>
                  </DetaildDataItem>
                  <DetaildDataItem>
                    <ItemTitle>
                      <MainFont
                        configuration={{ fontSize: 12, lineHeight: '1.33' }}
                      >
                        {t('max_power')}
                      </MainFont>
                    </ItemTitle>
                    <Item>
                      <MainFont
                        configuration={{ fontSize: 12, lineHeight: '1.55' }}
                      >
                        {connector?.maxPower || '-'}
                      </MainFont>
                    </Item>
                  </DetaildDataItem>
                  <DetaildDataItem>
                    <ItemTitle>
                      <MainFont
                        configuration={{ fontSize: 12, lineHeight: '1.33' }}
                      >
                        {t('last_usage')}
                      </MainFont>
                    </ItemTitle>
                    <Item>
                      <MainFont
                        configuration={{ fontSize: 12, lineHeight: '1.55' }}
                      >
                        {(connector?.lastUsage &&
                          moment(connector?.lastUsage).format(
                            'DD/MM/YYYY, h:mm:ss '
                          )) ||
                          '-'}
                      </MainFont>
                    </Item>
                  </DetaildDataItem>
                  <DetaildDataItem>
                    <ItemTitle>
                      <MainFont
                        configuration={{ fontSize: 12, lineHeight: '1.33' }}
                      >
                        {t('last_energy_supplied')}
                      </MainFont>
                    </ItemTitle>
                    <Item>
                      <MainFont
                        configuration={{ fontSize: 12, lineHeight: '1.55' }}
                      >
                        {(connector?.lastEnergySupplied &&
                          moment(connector?.lastEnergySupplied).format(
                            'DD/MM/YYYY, h:mm:ss '
                          )) ||
                          '-'}
                      </MainFont>
                    </Item>
                  </DetaildDataItem>
                  <DetaildDataItem>
                    <ItemTitle>
                      <MainFont
                        configuration={{ fontSize: 12, lineHeight: '1.33' }}
                      >
                        {t('total_energy_supplied')}
                      </MainFont>
                    </ItemTitle>
                    <Item>
                      <MainFont
                        configuration={{ fontSize: 12, lineHeight: '1.55' }}
                      >
                        {connector?.totalEnergySupplied || '-'}
                      </MainFont>
                    </Item>
                  </DetaildDataItem>
                </DetailsDataContainer>
              </DetailsWrapper>
            ))}
        </>
      )}
    </ContentWrapper>
  );
};

DetailsCard.propTypes = {
  details: PropTypes.object,
  corporate: PropTypes.bool
};

export default withMediaQueries(DetailsCard);
